import ButtonBase from "@mui/material/ButtonBase";
import  Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import styles from "./scheduleButton.module.css";

const ScheduleButton = ({ handleScheduleMeal }: { handleScheduleMeal: () => Promise<void> }) => (
    <Grid className={styles.container}>
      <ButtonBase className={styles.schedule_button} onClick={handleScheduleMeal}>
        <Typography className={styles.schedule_text} variant="captionparalell">
          Schedule
        </Typography>
      </ButtonBase>
    </Grid>
  );

export default ScheduleButton;